// Generated from FHIRPath.g4 by ANTLR 4.9.3
// jshint ignore: start
const antlr4 = require('../antlr4-index');

// This class defines a complete listener for a parse tree produced by FHIRPathParser.
class FHIRPathListener extends antlr4.tree.ParseTreeListener {

	// Enter a parse tree produced by FHIRPathParser#entireExpression.
	enterEntireExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#entireExpression.
	exitEntireExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#indexerExpression.
	enterIndexerExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#indexerExpression.
	exitIndexerExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#polarityExpression.
	enterPolarityExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#polarityExpression.
	exitPolarityExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#additiveExpression.
	enterAdditiveExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#additiveExpression.
	exitAdditiveExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#multiplicativeExpression.
	enterMultiplicativeExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#multiplicativeExpression.
	exitMultiplicativeExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#unionExpression.
	enterUnionExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#unionExpression.
	exitUnionExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#orExpression.
	enterOrExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#orExpression.
	exitOrExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#andExpression.
	enterAndExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#andExpression.
	exitAndExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#membershipExpression.
	enterMembershipExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#membershipExpression.
	exitMembershipExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#inequalityExpression.
	enterInequalityExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#inequalityExpression.
	exitInequalityExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#invocationExpression.
	enterInvocationExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#invocationExpression.
	exitInvocationExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#equalityExpression.
	enterEqualityExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#equalityExpression.
	exitEqualityExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#impliesExpression.
	enterImpliesExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#impliesExpression.
	exitImpliesExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#termExpression.
	enterTermExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#termExpression.
	exitTermExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#typeExpression.
	enterTypeExpression(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#typeExpression.
	exitTypeExpression(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#invocationTerm.
	enterInvocationTerm(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#invocationTerm.
	exitInvocationTerm(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#literalTerm.
	enterLiteralTerm(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#literalTerm.
	exitLiteralTerm(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#externalConstantTerm.
	enterExternalConstantTerm(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#externalConstantTerm.
	exitExternalConstantTerm(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#parenthesizedTerm.
	enterParenthesizedTerm(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#parenthesizedTerm.
	exitParenthesizedTerm(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#nullLiteral.
	enterNullLiteral(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#nullLiteral.
	exitNullLiteral(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#booleanLiteral.
	enterBooleanLiteral(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#booleanLiteral.
	exitBooleanLiteral(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#stringLiteral.
	enterStringLiteral(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#stringLiteral.
	exitStringLiteral(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#numberLiteral.
	enterNumberLiteral(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#numberLiteral.
	exitNumberLiteral(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#longNumberLiteral.
	enterLongNumberLiteral(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#longNumberLiteral.
	exitLongNumberLiteral(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#dateLiteral.
	enterDateLiteral(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#dateLiteral.
	exitDateLiteral(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#dateTimeLiteral.
	enterDateTimeLiteral(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#dateTimeLiteral.
	exitDateTimeLiteral(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#timeLiteral.
	enterTimeLiteral(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#timeLiteral.
	exitTimeLiteral(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#quantityLiteral.
	enterQuantityLiteral(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#quantityLiteral.
	exitQuantityLiteral(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#externalConstant.
	enterExternalConstant(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#externalConstant.
	exitExternalConstant(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#memberInvocation.
	enterMemberInvocation(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#memberInvocation.
	exitMemberInvocation(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#functionInvocation.
	enterFunctionInvocation(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#functionInvocation.
	exitFunctionInvocation(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#thisInvocation.
	enterThisInvocation(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#thisInvocation.
	exitThisInvocation(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#indexInvocation.
	enterIndexInvocation(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#indexInvocation.
	exitIndexInvocation(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#totalInvocation.
	enterTotalInvocation(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#totalInvocation.
	exitTotalInvocation(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#functn.
	enterFunctn(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#functn.
	exitFunctn(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#paramList.
	enterParamList(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#paramList.
	exitParamList(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#quantity.
	enterQuantity(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#quantity.
	exitQuantity(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#unit.
	enterUnit(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#unit.
	exitUnit(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#dateTimePrecision.
	enterDateTimePrecision(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#dateTimePrecision.
	exitDateTimePrecision(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#pluralDateTimePrecision.
	enterPluralDateTimePrecision(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#pluralDateTimePrecision.
	exitPluralDateTimePrecision(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#typeSpecifier.
	enterTypeSpecifier(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#typeSpecifier.
	exitTypeSpecifier(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#qualifiedIdentifier.
	enterQualifiedIdentifier(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#qualifiedIdentifier.
	exitQualifiedIdentifier(ctx) {
	}


	// Enter a parse tree produced by FHIRPathParser#identifier.
	enterIdentifier(ctx) {
	}

	// Exit a parse tree produced by FHIRPathParser#identifier.
	exitIdentifier(ctx) {
	}



}
module.exports = FHIRPathListener;
